var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseSvgNew(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.88053 14.1639C1.64829 14.1639 1.41605 14.0791 1.23858 13.91C0.884014 13.5717 0.884014 13.0224 1.23858 12.6838L14.2203 0.28523C14.5748 -0.0534099 15.1492 -0.0534099 15.5042 0.28523C15.8587 0.62352 15.8587 1.17281 15.5042 1.51145L2.52247 13.91C2.34501 14.0795 2.11277 14.1639 1.88053 14.1639Z",
    fill: "#424242"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8622 14.1639C14.63 14.1639 14.3977 14.0791 14.2203 13.91L1.23858 1.51145C0.884014 1.17316 0.884014 0.623869 1.23858 0.28523C1.59315 -0.0534099 2.16754 -0.0534099 2.52247 0.28523L15.5042 12.6838C15.8587 13.022 15.8587 13.5713 15.5042 13.91C15.3267 14.0795 15.0944 14.1639 14.8622 14.1639Z",
    fill: "#424242"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseSvgNew);
export default __webpack_public_path__ + "static/media/CloseSvgNew.76a71fe7.svg";
export { ForwardRef as ReactComponent };